// extracted by mini-css-extract-plugin
module.exports = {"list":"index-module--list--192K9","item":"index-module--item--35734","link":"index-module--link--NGCcU"};